/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'

import { hasAnySsoMethod, hasRedirectOnMount, redirectOnMount } from '@modules/auth/auth'

import AppLoadingRoot from '../../../../components/AppLoadingRoot'

import type { AllProps } from './types'

const LoginIndex: React.FunctionComponent<AllProps> = ({
  fetchAuthMethods,
  authMethods,
  newBearerToken,
  fetchAuthMethodsRequest,
  redirectAfterLogin,
}) => {
  const [params] = useSearchParams()
  const redirectTo = params.get('redirectTo') ?? undefined

  useEffect(() => {
    if (hasRedirectOnMount(newBearerToken)) {
      redirectOnMount({ redirectTo, redirectAfterLogin, newBearerToken })
      return
    }

    if (!authMethods && !fetchAuthMethodsRequest.inProgress) {
      fetchAuthMethods()
    }
  }, [])

  const useSso = hasAnySsoMethod(authMethods)

  if (!authMethods || fetchAuthMethodsRequest.inProgress) {
    return <AppLoadingRoot />
  }

  if (hasRedirectOnMount(newBearerToken)) {
    return null
  }

  if (useSso) {
    return <Navigate to={{ pathname: '/login/sso', search: location.search }} />
  }

  return <Navigate to={{ pathname: '/login/basic', search: location.search }} />
}

export default LoginIndex
